import { Store } from "@tanstack/store";

export interface QuotaGuard {
  recordFailure(): boolean; // returns true once the threshold is reached
  recordSuccess(): void;
}

export function createQuotaGuard(threshold = 3): QuotaGuard {
  let streak = 0;
  return {
    recordFailure() {
      streak++;
      return streak >= threshold;
    },
    recordSuccess() {
      streak = 0;
    },
  };
}

/** App-wide instance used by the real persist pass, plus a store the UI can
 * subscribe to for the blocking "device storage full" notice. Trips once
 * and stays tripped for the session — a device that's actually full won't
 * un-trip itself, and resetting on the next unrelated success would just
 * hide the notice while the underlying problem remains. */
export const quotaExceededStore = new Store(false);

const guard = createQuotaGuard();
export const appQuotaGuard: QuotaGuard = {
  recordFailure() {
    const tripped = guard.recordFailure();
    if (tripped) quotaExceededStore.setState(() => true);
    return tripped;
  },
  recordSuccess() {
    guard.recordSuccess();
  },
};
